import axios from "axios";
export const ARVAN_API_KEY = "apikey 1a89fd23-763c-58fb-83f4-af2a8566cc84";
export const CHAT_AI_KEY = "apikey 2d72c2dc-e2ba-52b0-8dee-72c984c0a705";
export function getVodServices(channelId) {
  return axios.get(
    `https://napi.arvancloud.ir/vod/2.0/channels/${channelId}/videos`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: ARVAN_API_KEY,
      },
    }
  );
}
export function getVideosSubtitle(videoId) {
  return axios.get(
    `https://napi.arvancloud.ir/vod/2.0/videos/${videoId}/subtitles`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: ARVAN_API_KEY,
      },
    }
  );
}
export function getChatService(message) {
  return axios.post(
    `https://arvancloudai.ir/gateway/models/GPT-4.1-Mini/PBoQ8qauy81713mmXCvIE4xvzw11HRpM2G1UjEt917Qv9BYI18JZJhbi3cHUVmPbBM3yeGMrqeVeX22Br406ILB_cTH3hvxZmFLUS6SOqoUUHHSngBsme9FpJ9YU-8yshpBJ1j_6herZeTNHA6qHHrsj9F8MwmXBOTq5UZAQAENERmpz63lhxE0SHIkdf0gF3G2Hg35jJnk-6QON-doJZE82DoRDJnscW1dMwNiVp0x0HINQyIEcqKB9bBQDYQ/v1/chat/completions`,
    {
      model: "GPT-4-1-Mini-iexbi",
      messages: [{ role: "user", content: message }],
      max_tokens: 3000,
      temperature: 0.7,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: CHAT_AI_KEY,
      },
    }
  );
}
export function getUserChannels() {
  return axios.get("https://napi.arvancloud.ir/vod/2.0/channels", {
    headers: {
      "Content-Type": "application/json",
      Authorization: ARVAN_API_KEY,
    },
  });
}
